// extracted by mini-css-extract-plugin
export default {"container":"style_container__7lOY4","header":"style_header__HjT70","profilePicture":"style_profilePicture__J0a4i"};